import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface UiStore {
  /** Desktop sidebar collapsed to an icon-only rail. Persisted across sessions. */
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  /**
   * Desktop only: the full-screen Settings popup overlay is open. Settings is
   * presented as a sheet OVER the whole app (so it slides up over the sidebar and
   * reveals the app intact on dismiss). Ephemeral - never persisted, so a reload
   * never reopens it.
   */
  settingsOpen: boolean;
  setSettingsOpen: (open: boolean) => void;
  settingsTabRestaurantId: string | null;
  setSettingsTabRestaurantId: (restaurantId: string | null) => void;
}

export const useUiStore = create<UiStore>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      settingsOpen: false,
      setSettingsOpen: (open) => set({ settingsOpen: open }),
      settingsTabRestaurantId: null,
      setSettingsTabRestaurantId: (restaurantId) => set({ settingsTabRestaurantId: restaurantId }),
    }),
    {
      name: 'restaurant-ui',
      storage: createJSONStorage(() => localStorage),
      // Only the sidebar preference persists; the Settings overlay is transient.
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed }),
    },
  ),
);
